import React, { useEffect, useState } from 'react'
import { CForm, CRow } from '@coreui/react'
import { Dialog } from 'primereact/dialog'
import { Button } from '@mui/material'
import { useAuth } from '../contexts/AuthContext'
import { usePayment } from '../contexts/PaymentContext'
import CInput from './CInput'

function AddPayment({ visible, editMode, editPaymentId, handleClose, fetchPayments }) {
    const { getSinglePayment, createPayment, updatePayment } = usePayment();
    const { restaurantId } = useAuth();

    const [validated, setValidated] = useState(false);
    const [paymentDetail, setPaymentDetail] = useState({
        name: '',
        restaurant_id: restaurantId
    });

    useEffect(() => {
        fetchSinglePayment();
    }, [editMode, editPaymentId]);

    const fetchSinglePayment = async () => {
        if (editPaymentId) {
            const payment = await getSinglePayment(editPaymentId)
            if(payment){
                setPaymentDetail(payment.data);
            }
        }
    }

    const handleSubmit = async (e) => {
        e.preventDefault();

        const form = e.currentTarget;
        setValidated(true);

        if (form.checkValidity() === false) {
            e.stopPropagation();

            const firstInvalidInput = form.querySelector(':invalid');
            if (firstInvalidInput) {
                firstInvalidInput.focus();
                firstInvalidInput.scrollIntoView({ behavior: 'smooth', block: 'center' });
            }
        } else {
            try {
                if (visible && restaurantId) {
                    const data = await createPayment({ ...paymentDetail, restaurant_id: restaurantId });
                    if (!data.error) {
                        handleClose();
                        setPaymentDetail({
                            name: '',
                            restaurant_id: restaurantId
                        });
                        fetchPayments()
                    }
                } else if (editMode && editPaymentId && restaurantId) {
                    const data = await updatePayment(editPaymentId, { ...paymentDetail, restaurant_id: restaurantId });
                    if (!data.error) {
                        handleClose();
                        setPaymentDetail({
                            name: '',
                            restaurant_id: restaurantId
                        });
                        fetchPayments()
                    }
                }
            } catch (error) {
                console.log(error);
            }
        }
    }

    return (
        <div>
            <Dialog draggable={false} header={`${visible ? 'Create Payment' : 'Edit Payment'}`} visible={visible || (editMode && editPaymentId !== null)} style={{ width: '30vw' }} onHide={handleClose}>
                <CForm onSubmit={handleSubmit} noValidate validated={validated}>
                    <div className='fields-container'>
                        <CRow className="mb-3 mt-3">
                            <CInput
                                label="Name"
                                type="text"
                                value={paymentDetail.name}
                                onChange={(value) => setPaymentDetail({ ...paymentDetail, name: value })}
                                required={true}
                                errorMessage='Name is required.'
                            />
                        </CRow>
                    </div>
                    <div className="d-flex p-jc-end justify-content-end button-container">
                        <div className='d-flex'>
                            <Button onClick={handleClose} fullWidth variant="contained" color="inherit" >
                                Cancel
                            </Button>
                            <Button fullWidth variant="contained" color='primary' type="submit" className='ms-3'>
                                Submit
                            </Button>
                        </div>
                    </div>
                </CForm>
            </Dialog>
        </div>
    )
}

export default AddPayment